var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "saas_remind",
      attrs: {
        model: _vm.value.config,
        disabled: _vm.disabled,
        rules: _vm.rules,
      },
    },
    [
      _c("div", [_vm._v("示意样式")]),
      _c("el-image", {
        staticClass: "icon",
        attrs: { fit: "contain", src: _vm.icon },
      }),
      _c(
        "el-form-item",
        { staticClass: "title", attrs: { prop: "title" } },
        [
          _c("div", [
            _vm._v(" 组件名称 "),
            _c("span", { staticClass: "tips" }, [_vm._v("展示在组件左侧")]),
          ]),
          _c("el-input", {
            attrs: { placeholder: "请输入组件名称", clearable: "" },
            model: {
              value: _vm.value.config.title,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "title", $$v)
              },
              expression: "value.config.title",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "margin_top",
          attrs: {
            prop: "margin_top",
            rules: [{ type: "number", message: "间距必须为数字值" }],
          },
        },
        [
          _c("div", [_vm._v(" 与上方组件的间距 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入间距", clearable: "" },
            model: {
              value: _vm.value.config.margin_top,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "margin_top", _vm._n($$v))
              },
              expression: "value.config.margin_top",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "z_index",
          attrs: {
            prop: "z_index",
            rules: [
              {
                required: true,
                pattern: /^(?:[1-9]|[1-9][0-9])$/,
                message: "请输入1-99之间的整数！",
              },
            ],
          },
        },
        [
          _c("div", [_vm._v(" 层级高度值 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入层级高度值", clearable: "" },
            model: {
              value: _vm.value.config.z_index,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "z_index", _vm._n($$v))
              },
              expression: "value.config.z_index",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }